import { enTranslations } from './translations.en';

export const deTranslations: Record<string, string> = {
  ...enTranslations,
  'nav.overview': 'Übersicht',
  'nav.overviewDesc': 'Betriebsstatus, Orchestrierung und Auslieferungskanäle',
  'nav.reception': 'Rezeption',
  'nav.receptionDesc': 'Operative Listen, manuelle Ausgabe und Massenimport',
  'nav.administration': 'Administration',
  'nav.administrationDesc':
    'Spezielle Listen und Formulare für Tenants, Vendoren, Standorte, Benutzer und Infrastruktur',
  'shell.consoleTitle': 'Betriebskonsole',
  'shell.consoleDescription':
    'Mandantenfähiges Dashboard für PMS-Abläufe, Rezeptionsprozesse, Provisionierung des Netzwerk-Controllers und DPSK-Verteilung.',
  'shell.livePosture': 'Live-Status',
  'shell.loadingLocation': 'Standortkontext wird geladen',
  'shell.healthy': 'Stabiler Betriebsablauf',
  'shell.attention': 'Aufmerksamkeit beim Auslieferungskanal',
  'shell.authSession': 'Authentifizierte Sitzung',
  'shell.guestOperator': 'Demo-Benutzer',
  'shell.noRole': 'Keine Rolle',
  'shell.currentWorkspace': 'Aktueller Arbeitsbereich',
  'shell.workspaceDescription': 'Aktiver Kontext für die ausgewählte Seite.',
  'shell.filters': 'Filter',
  'shell.tenant': 'Tenant',
  'shell.location': 'Hotel / Standort',
  'shell.language': 'Sprache',
  'shell.theme': 'Design',
  'shell.theme.system': 'System',
  'shell.theme.light': 'Hell',
  'shell.loadingData': 'Daten werden aktualisiert',
  'shell.searchTenant': 'Tenant suchen',
  'shell.searchLocation': 'Hotel oder Standort suchen',
  'shell.noSearchResults': 'Keine Treffer',
  'shell.closeFilters': 'Filter schließen',
  'dialog.cancel': 'Abbrechen',
  'dialog.deleteTitle': 'Löschen bestätigen',
  'dialog.extendTitle': 'Verlängerung bestätigen',
  'dialog.revokeTitle': 'Widerruf bestätigen',
  'shell.noPms': 'Kein PMS verknüpft',
  'shell.noController': 'Kein Controller verknüpft',
  'shell.tvOn': 'TV aktiv',
  'shell.tvPending': 'TV ausstehend',
  'shell.emailOn': 'E-Mail aktiv',
  'shell.emailPending': 'E-Mail ausstehend',
  'shell.exitSession': 'Abmelden',
  'auth.mode.mock': 'Demo-Modus',
  'login.badge': 'Hospitality-Betriebskonsole',
  'login.title': 'Sicherer Zugriff auf die Hospitality-Plattform.',
  'login.description':
    'Verwalte Tenants, Standorte, Benutzer, Vendoren und WLAN-Zugangsdaten in einer einzigen Konsole für den täglichen Betrieb.',
  'login.inputTitle': 'Tenants und Standorte',
  'login.inputBody': 'Steuere Objekte, Einheiten, Vendoren und operative Einstellungen an einem Ort.',
  'login.logicTitle': 'Rezeption und Zugangsdaten',
  'login.logicBody':
    'Erstelle, verlängere und überwache WLAN-Codes für Gäste, Mitarbeitende und Events ohne Zusatzschritte.',
  'login.outputTitle': 'Operative Transparenz',
  'login.outputBody': 'Prüfe Service-Status, Warteschlangen und Zustellung von Zugangsdaten auf einen Blick.',
  'login.accessMode': 'Anmeldung',
  'login.demoWorkspace': 'Plattform erkunden',
  'login.keycloakWorkspace': 'Willkommen zurück',
  'login.demoDescription': 'Öffne die Demo-Umgebung, um die Hauptabläufe mit Beispieldaten zu erkunden.',
  'login.keycloakDescription': 'Melde dich mit deinem Firmenkonto an, um fortzufahren.',
  'login.enterDemo': 'Demo-Dashboard öffnen',
  'login.continueKeycloak': 'Zur Plattform anmelden',
  'login.readyTitle': 'Zentrale Verwaltung',
  'login.readyBody':
    'Tenants, Standorte, Einheiten, Benutzer und Kataloge stehen in einer einzigen Betriebskonsole bereit.',
  'login.supportTitle': 'Tägliche Abläufe',
  'login.supportBody':
    'Arbeite mit Rezeptionsprozessen, WLAN-Zugangsdaten und Servicekonfigurationen in einer einfacheren Oberfläche.',
  'login.demoNote': 'Die Demo-Umgebung nutzt Beispieldaten und dient nur zur Erkundung.',
  'login.switchNote': 'Wenn du Probleme bei der Anmeldung hast, wende dich an den Service-Administrator.',
  'overview.context': 'Betriebsübersicht',
  'overview.title': 'Status des ausgewählten Standorts',
  'overview.subtitle':
    'Schnelle Kennzahlen zu DPSK-Nutzung, VLAN-Mapping und operativer Last des Standorts.',
  'reception.pageKicker': 'Rezeptionsbetrieb',
  'reception.pageTitle': 'DPSK-Ausgabe und Lebenszyklusverwaltung',
  'reception.pageDescription':
    'Der Rezeptionsbereich ist in eigene Seiten gegliedert: Codeliste, manuelle Ausgabe und Massenimport.',
  'admin.pageKicker': 'Administrative Verwaltung',
  'admin.pageTitle': 'Tenants, Vendoren, Standorte und Benutzer',
  'admin.pageDescription':
    'Der Administrationsbereich nutzt eigene Seiten für Tenants, Vendor-Kataloge, Standorte, Benutzer und Infrastruktur.',
  'admin.actions.newRoomAssignment': 'Neue Einheit',
  'admin.actions.assignRoom': 'Einheit bearbeiten',
  'admin.form.createRoomAssignment': 'Einheit erstellen',
  'admin.form.updateRoomAssignment': 'Einheit aktualisieren',
  'admin.form.roomAssignmentDescription':
    'Definiere das WLAN-Mapping für eine einzelne Einheit. Die Konfiguration ist sofort im Standortinventar und in den Rezeptionsabläufen verfügbar.',
  'admin.form.roomNotFound': 'Einheit nicht gefunden.',
  'admin.form.locationRequiredForRoom':
    'Wähle zuerst einen Standort aus, bevor du eine Einheit anlegst.',
  'admin.message.roomAssignmentSaved':
    'Infrastrukturkonfiguration für {name} gespeichert.',
  'table.pagination.previous': 'Zurück',
  'table.pagination.next': 'Weiter',
  'table.pagination.summary': '{from}-{to} von {total}',
  'app.badge': 'Lumen Hospitality DPSK',
  'auth.mode.keycloak': 'Keycloak',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'overview.card.active.label': 'Aktive Identitäten',
  'overview.card.active.caption': 'DPSKs, die am ausgewählten Standort aktuell gültig sind',
  'overview.card.scheduled.label': 'Geplante Anreisen',
  'overview.card.scheduled.caption': 'Zugangsdaten wurden bereits erstellt und warten auf Check-in oder Eventstart',
  'overview.card.mapped.label': 'Zugeordnete Einheiten',
  'overview.card.mapped.caption': '{rooms} Zimmer, {publicAreas} Gemeinschaftsbereiche, {eventHalls} Eventsäle',
  'overview.card.daily.label': 'Tagesvolumen',
  'overview.card.daily.caption': 'Erwartete Last zwischen PMS, Rezeption und manuellen Anfragen',
  'overview.locationHealth': 'Servicezustand',
  'overview.deliveryChannels': 'Auslieferungskanäle',
  'overview.connected': 'Verbunden',
  'overview.fallback': 'Fallback aktiv',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'RADIUS-Protokolle bleiben für Compliance und Analysen zentralisiert.',
  'overview.operationalFlow': 'Betriebsablauf',
  'overview.flowAligned': 'Mit den Szenarien des Dokuments abgestimmt',
  'overview.channelMix': 'Kanalmix',
  'overview.distributionSplit': 'Verteilung der Auslieferung',
  'overview.channelShare': '{share}% der sichtbaren Gesamtmenge',
  'overview.infrastructure': 'Einheiten und VLANs',
  'overview.infrastructureDesc': 'Zimmer, Gemeinschaftsbereiche und Eventsäle, die an diesem Standort verfügbar sind.',
  'overview.alerts': 'Hinweisübersicht',
  'overview.alertsTitle': 'Aktuelle Risiken und Auffälligkeiten',
  'overview.noAlerts': 'Am aktuellen Standort sind keine offenen Auffälligkeiten vorhanden.',
  'overview.queue': 'Hintergrundwarteschlange',
  'overview.queueTitle': 'Status der Massenimporte',
  'overview.queueProgress': '{processed}/{total} verarbeitet, Ziel-VLAN {vlan}',
  'overview.credentials': 'Aktuelle Zugangsdaten',
  'overview.credentialsTitle': 'Zuletzt ausgegebene DPSKs',
  'overview.table.guest': 'Gast',
  'overview.table.space': 'Einheit',
  'overview.table.type': 'Typ',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'PAN-Modus',
  'overview.table.source': 'Quelle',
  'overview.table.channels': 'Kanäle',
  'overview.table.validity': 'Gültigkeit',
  'overview.table.devices': 'Geräte',
  'overview.flow.trigger.title': 'PMS- / Rezeptionsauslöser',
  'overview.flow.trigger.body': 'Webhook, Operatorformular oder CSV erzeugen die Zugriffsanfrage.',
  'overview.flow.normalize.title': 'Identitätsnormalisierung',
  'overview.flow.normalize.body':
    'Die Plattform weist Hotel, Einheit, VLAN und das gültige Zeitfenster zu.',
  'overview.flow.provision.title': 'Netzwerk-Controller-Provisionierung',
  'overview.flow.provision.body':
    'Die DPSK wird mit dem zugeordneten VLAN und ihrem Lebenszyklus verknüpft.',
  'overview.flow.deliver.title': 'Kanalzustellung',
  'overview.flow.deliver.body': 'TV, E-Mail, Dashboard oder Druck erhalten QR-Code und Passwort.',
  'overview.flow.monitor.title': 'Monitoring und Accounting',
  'overview.flow.monitor.body':
    'Nutzung, Warteschlangen, Kanaladoption und Accounting bleiben für Operations sichtbar.',
  'validation.required': 'Pflichtfeld.',
  'validation.email': 'Gib eine gültige E-Mail-Adresse ein.',
  'validation.minValue': 'Gib einen gültigen Wert ein.',
  'validation.fixErrors': 'Korrigiere die markierten Felder vor dem Speichern.',
  'validation.dateOrder': 'Das Enddatum muss nach dem Startdatum liegen.',
  'validation.selectOne': 'Wähle mindestens ein Element aus.',
  'toast.dismiss': 'Benachrichtigung schließen',
  'toast.error.network': 'Der Backend-Dienst ist nicht erreichbar.',
  'toast.error.badRequest': 'Die Anfrage ist ungültig.',
  'toast.error.unauthorized': 'Sitzung nicht autorisiert. Bitte melde dich erneut an.',
  'toast.error.forbidden': 'Du hast nicht die erforderlichen Berechtigungen für diese Aktion.',
  'toast.error.notFound': 'Die angeforderte Ressource wurde nicht gefunden.',
  'toast.error.conflict': 'Die Aktion kann wegen eines Statuskonflikts nicht abgeschlossen werden.',
  'toast.error.validation': 'Die gesendeten Daten sind ungültig.',
  'toast.error.server': 'Der Server hat einen internen Fehler zurückgegeben.',
  'toast.error.unavailable': 'Der Dienst ist vorübergehend nicht verfügbar.',
  'toast.error.genericStatus': 'HTTP-Fehler {status}: Anfrage fehlgeschlagen.',
  'toast.error.unexpected': 'Während des HTTP-Aufrufs ist ein unerwarteter Fehler aufgetreten.',
  'channel.tv': 'TV',
  'channel.email': 'E-Mail',
  'channel.dashboard': 'Dashboard',
  'channel.print': 'Druck',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'Rezeption',
  'codeSource.bulk': 'Bulk',
  'queueStatus.queued': 'In Warteschlange',
  'queueStatus.running': 'Läuft',
  'queueStatus.completed': 'Abgeschlossen',
  'queueStatus.attention': 'Achtung',
  'spaceKind.room': 'Zimmer',
  'spaceKind.public-area': 'Gemeinschaftsbereich',
  'spaceKind.event-hall': 'Eventsaal',
  'assignment.room': 'Zimmer',
  'assignment.group': 'Gruppe',
  'assignment.common': 'Gemeinsam',
  'panMode.private': 'Privat',
  'panMode.shared-group': 'Geteilte Gruppe',
  'panMode.public': 'Öffentlich',
  'role.tv-integration': 'TV-Integration',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'Administrator',
  'role.reception': 'Concierge',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'Hotel',
  'locationCategory.resort': 'Resort',
  'locationCategory.conference': 'Konferenzstandort',
  'locationState.active': 'Aktiv',
  'locationState.disabled': 'Deaktiviert',
  'locationState.pending': 'Ausstehend',
  'locationState.stable': 'Stabil',
  'locationState.attention': 'Achtung',
  'unitStatus.available': 'Verfügbar',
  'unitStatus.disabled': 'Deaktiviert',
  'unitStatus.occupied': 'Belegt',
  'userStatus.active': 'Aktiv',
  'userStatus.invited': 'Eingeladen',
  'userStatus.disabled': 'Deaktiviert',
  'reception.tab.issue': 'Ausgabe',
  'reception.tab.codes': 'Code-Verwaltung',
  'reception.tab.bulk': 'Massenimport',
  'reception.summary.active': 'Aktiv',
  'reception.summary.scheduled': 'Geplant',
  'reception.summary.archived': 'Archiviert',
  'reception.summary.queue': 'Bulk-Jobs',
  'reception.issue.kicker': 'Manuelle Ausgabe',
  'reception.issue.title': 'Eine DPSK für Gäste und Ausnahmefälle erstellen',
  'reception.issue.description':
    'Für Walk-ins, Lieferanten, Barzugang oder PMS-Fallback. QR-Code und Klartext-Passwort erzeugen.',
  'reception.fields.firstName': 'Vorname',
  'reception.fields.lastName': 'Nachname',
  'reception.fields.email': 'E-Mail',
  'reception.fields.space': 'Einheit',
  'reception.fields.reference': 'Buchungs- / Voucher-Referenz',
  'reception.fields.validFrom': 'Gültig ab',
  'reception.fields.validUntil': 'Gültig bis',
  'reception.fields.devicesAllowed': 'Erlaubte Geräte',
  'reception.fields.deliveryChannels': 'Auslieferungskanäle',
  'reception.fields.notes': 'Notizen des Operators',
  'reception.preview.kicker': 'Voucher-Vorschau',
  'reception.preview.title': 'Operator-Karte',
  'reception.preview.empty': 'Wähle eine Einheit aus, um den QR-Code in der Vorschau anzuzeigen.',
  'reception.preview.guest': 'Gast',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'PAN-Modus',
  'reception.preview.expires': 'Ablauf',
  'reception.lastCreated': 'Zuletzt erstellter Code',
  'reception.lastCreatedEmpty':
    'Erstelle eine manuelle DPSK, um hier die letzte Voucher-Zusammenfassung anzuzeigen.',
  'reception.generate': 'DPSK erstellen',
  'reception.creating': 'Wird erstellt...',
  'reception.codes.kicker': 'Code-Verwaltung',
  'reception.codes.title': 'Voucher filtern, verlängern oder widerrufen',
  'reception.filter.all': 'Alle',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'Rezeption',
  'reception.filter.bulk': 'Bulk',
  'reception.searchPlaceholder': 'Gast oder Referenz suchen',
  'reception.activeList': 'Aktiv / geplant',
  'reception.archivedList': 'Archiviert / ungültig',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'Widerrufen',
  'reception.actions.new': 'Neue DPSK',
  'reception.actions.backToCodes': 'Zurück zu den Codes',
  'reception.actions.showQr': 'QR anzeigen',
  'reception.actions.printQr': 'QR drucken',
  'reception.confirm.extend': 'Voucher {name} um 24 Stunden verlängern?',
  'reception.confirm.revoke': 'Voucher {name} widerrufen?',
  'reception.activeEmpty': 'Keine aktiven oder geplanten Codes entsprechen den aktuellen Filtern.',
  'reception.archivedEmpty': 'Keine archivierten oder widerrufenen Codes entsprechen den aktuellen Filtern.',
  'reception.bulk.kicker': 'Massen-Onboarding',
  'reception.bulk.title': 'CSV-Import für Gruppen und Veranstaltungen',
  'reception.bulk.loadFile': 'Datei laden',
  'reception.bulk.mode': 'Bulk-Modus',
  'reception.bulk.modeShared': 'Gemeinsame Gruppen-VLAN',
  'reception.bulk.modeIsolated': 'VLAN / Isolation pro Einheit',
  'reception.bulk.defaultSpace': 'Standardeinheit',
  'reception.bulk.requestedBy': 'Angefordert von',
  'reception.bulk.csvBody': 'CSV-Inhalt',
  'reception.bulk.queue': 'Import in Warteschlange stellen',
  'reception.bulk.queueing': 'Wird in die Warteschlange gestellt...',
  'reception.bulk.templateHint':
    'Erwartete Spalten: firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'Warteschlangenstatus',
  'reception.bulk.jobsTitle': 'Aktuelle Aktivität',
  'reception.emptyLocation': 'Wähle einen Standort mit verfügbaren Einheiten aus oder lege ihn an.',
  'reception.message.created': '{id} für {name} erstellt.',
  'reception.message.bulkQueued': 'Job {id} mit {imported} Identitäten in die Warteschlange gestellt ({status}).',
  'reception.message.extended': 'Gültigkeit für {id} um 24 Stunden verlängert.',
  'reception.message.revoked': 'Code {id} widerrufen.',
  'admin.vendorHintTitle': 'Vendor-Kataloge',
  'admin.vendorHintBody':
    'Bevor du einen Standort erstellst oder aktualisierst, kannst du die Vendor-Kataloge für Controller und PMS registrieren, damit Dropdowns und Konfigurationsfelder in den Standortformularen bereitstehen.',
  'admin.card.tenants.label': 'Tenants',
  'admin.card.tenants.caption': 'Mandantenfähiges Portfolio, das im Panel verwaltet wird',
  'admin.card.locations.label': 'Standorte',
  'admin.card.locations.caption': 'Hotels, Resorts und Veranstaltungsorte im Prototyp',
  'admin.card.users.label': 'Benutzer',
  'admin.card.users.caption': 'Operative Rollen und Zuweisungen werden über den Mock-Status verwaltet',
  'admin.card.spaces.label': 'Einheiten / VLANs',
  'admin.card.spaces.caption': 'Aktuelles Einheiteninventar für den ausgewählten Standort',
  'admin.tab.tenants': 'Tenants',
  'admin.tab.locations': 'Standorte',
  'admin.tab.users': 'Benutzer',
  'admin.tab.controllerVendors': 'Controller-Vendoren',
  'admin.tab.pmsVendors': 'PMS-Vendoren',
  'admin.tab.infrastructure': 'Infrastruktur',
  'admin.tenants.kicker': 'Tenant-Verwaltung',
  'admin.tenants.title': 'Tenants erstellen und aktualisieren',
  'admin.locations.kicker': 'Standortverwaltung',
  'admin.locations.title': 'Hotels, Resorts und Veranstaltungsorte verwalten',
  'admin.locations.filterHint':
    'Wähle einen Tenant aus, um nur die zugehörigen Standorte anzuzeigen, ohne die globalen operativen Filter zu verwenden.',
  'admin.users.kicker': 'Benutzerverwaltung',
  'admin.users.title': 'Rollen, Tenant-Scopes und Standort-Scopes',
  'admin.controllerVendors.kicker': 'Controller-Katalog',
  'admin.controllerVendors.title': 'Controller-Vendoren registrieren und verwalten',
  'admin.controllerVendors.empty': 'Es sind noch keine Controller-Vendoren registriert.',
  'admin.controllerVendors.emptyHint':
    'Füge den ersten Controller-Vendor hinzu, damit er beim Onboarding von Standorten verfügbar ist.',
  'admin.pmsVendors.kicker': 'PMS-Katalog',
  'admin.pmsVendors.title': 'PMS-Vendoren registrieren und verwalten',
  'admin.pmsVendors.empty': 'Es sind noch keine PMS-Vendoren registriert.',
  'admin.pmsVendors.emptyHint':
    'Füge den ersten PMS-Vendor hinzu, damit er beim Onboarding von Standorten verfügbar ist.',
  'admin.infrastructure.kicker': 'Inventar und Integrationen',
  'admin.infrastructure.title': 'Einheiten, VLANs und Konnektor-Bereitschaft',
  'admin.form.new': 'Neu',
  'admin.form.reset': 'Zurücksetzen',
  'admin.form.create': 'Erstellen',
  'admin.form.update': 'Aktualisieren',
  'admin.form.name': 'Name',
  'admin.form.brand': 'Marke / Beschreibung',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'DPSK-Abdeckung %',
  'admin.form.city': 'Stadt',
  'admin.form.category': 'Kategorie',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'PMS-Vendor',
  'admin.form.pds': 'PDS-Konfiguration',
  'admin.form.controller': 'Controller',
  'admin.form.controllerVendor': 'Controller-Vendor',
  'admin.form.tv': 'TV-Integration',
  'admin.form.email': 'E-Mail-Integration',
  'admin.form.integrations': 'Integrationen',
  'admin.form.state': 'Status',
  'admin.form.dailyCheckIns': 'Tägliche Check-ins',
  'admin.form.activeGuests': 'Aktive Gäste',
  'admin.form.bulkQueue': 'Bulk-Warteschlange',
  'admin.form.note': 'Operative Notiz',
  'admin.form.timezone': 'Zeitzone',
  'admin.form.linkedTenant': 'Zugeordneter Tenant',
  'admin.form.role': 'Rolle',
  'admin.form.status': 'Benutzerstatus',
  'admin.form.tenantScope': 'Tenant-Scope',
  'admin.form.locationScope': 'Standort-Scope',
  'admin.form.fieldSchema': 'Feldschema',
  'admin.form.fieldName': 'Feldname',
  'admin.form.fieldType': 'Feldtyp',
  'admin.form.fieldsHelp': 'Definiere mindestens ein zusätzliches Feld für den Vendor.',
  'admin.form.selectVendor': 'Vendor auswählen',
  'admin.form.selectVendorFirst': 'Wähle zuerst einen Vendor aus, um die erforderlichen Felder zu konfigurieren.',
  'admin.form.pmsConfiguration': 'PMS-Konfiguration',
  'admin.form.controllerConfiguration': 'Controller-Konfiguration',
  'admin.form.vendorConfigurationHint':
    'Fülle alle Felder aus, die vom ausgewählten Vendor-Katalogeintrag verlangt werden.',
  'admin.form.noPmsVendorsAvailable':
    'Es ist noch kein PMS-Vendor verfügbar. Registriere zuerst den PMS-Katalog.',
  'admin.form.noControllerVendorsAvailable':
    'Es ist noch kein Controller-Vendor verfügbar. Registriere zuerst den Controller-Katalog.',
  'admin.form.addField': 'Feld hinzufügen',
  'admin.form.removeField': 'Feld entfernen',
  'admin.form.createControllerVendor': 'Controller-Vendor erstellen',
  'admin.form.createPmsVendor': 'PMS-Vendor erstellen',
  'admin.form.updateControllerVendor': 'Controller-Vendor aktualisieren',
  'admin.form.updatePmsVendor': 'PMS-Vendor aktualisieren',
  'admin.form.controllerVendorNotFound': 'Controller-Vendor nicht gefunden.',
  'admin.form.pmsVendorNotFound': 'PMS-Vendor nicht gefunden.',
  'admin.form.vendorFieldType.string': 'Text',
  'admin.form.vendorFieldType.number': 'Zahl',
  'admin.form.vendorFieldType.boolean': 'Boolesch',
  'admin.form.vendorFieldType.password': 'Passwort',
  'admin.form.unitType': 'Einheitstyp',
  'admin.form.assignment': 'Zuweisung',
  'admin.form.unitStatus': 'Status der Einheit',
  'admin.list.portfolio': 'Portfolio',
  'admin.list.properties': 'Objekte',
  'admin.list.coverage': 'Abdeckung',
  'admin.list.alerts': 'Warnungen',
  'admin.list.noneTenants': 'Es sind noch keine Tenants registriert.',
  'admin.list.noneLocations': 'Für den ausgewählten Tenant sind keine Standorte verfügbar.',
  'admin.tenants.emptyHint': 'Erstelle den ersten Tenant, um das Multi-Tenant-Onboarding der Plattform zu starten.',
  'admin.actions.edit': 'Bearbeiten',
  'admin.actions.toggleStatus': 'Status umschalten',
  'admin.actions.newTenant': 'Neuer Tenant',
  'admin.actions.newLocation': 'Neuer Standort',
  'admin.actions.newUser': 'Neuer Benutzer',
  'admin.actions.newControllerVendor': 'Neuer Controller-Vendor',
  'admin.actions.newPmsVendor': 'Neuer PMS-Vendor',
  'admin.actions.manageInfrastructure': 'Infrastruktur',
  'admin.actions.backToLocation': 'Zurück zum Standort',
  'admin.actions.backToList': 'Zurück zur Liste',
  'admin.actions.delete': 'Löschen',
  'admin.infrastructure.inventory': 'Einheiteninventar',
  'admin.infrastructure.roomAssignments': 'Einzelraum-Zuweisungen',
  'admin.infrastructure.roomAssignmentsDesc':
    'Jeder Raum wird einzeln mit SSID, VLAN und PAN-Modus zugeordnet. Nutze diesen Bereich, um die Zuweisung für einen einzelnen Raum zu erstellen oder zu korrigieren.',
  'admin.infrastructure.locationScopeDesc':
    'Diese Seite gehört zum ausgewählten Standort. Die Infrastrukturzuweisung wird direkt innerhalb des Standorts verwaltet.',
  'admin.infrastructure.sharedSpaces': 'Gemeinsame Einheiten und Veranstaltungssäle',
  'admin.infrastructure.noRooms': 'Für den ausgewählten Standort ist kein Raum konfiguriert.',
  'admin.infrastructure.noSharedSpaces': 'Keine gemeinsame Einheit ist konfiguriert.',
  'admin.infrastructure.roomPreview': 'Zuweisungsvorschau',
  'admin.infrastructure.readiness': 'Integrationsbereitschaft',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ im Backend noch zu definieren',
  'admin.integrations.pdsPlaceholder': 'PDS-Konfiguration noch festzulegen',
  'admin.form.createTenant': 'Tenant erstellen',
  'admin.form.updateTenant': 'Tenant aktualisieren',
  'admin.form.tenantNotFound': 'Tenant nicht gefunden.',
  'admin.form.createLocation': 'Standort erstellen',
  'admin.form.updateLocation': 'Standort aktualisieren',
  'admin.form.locationNotFound': 'Standort nicht gefunden.',
  'admin.form.createUser': 'Benutzer erstellen',
  'admin.form.updateUser': 'Benutzer aktualisieren',
  'admin.form.userNotFound': 'Benutzer nicht gefunden.',
  'admin.form.roomName': 'Raum',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'Service-VLAN',
  'admin.form.networkId': 'Netzwerk-ID',
  'admin.form.capacity': 'Kapazität',
  'admin.message.tenantSaved': 'Tenant {name} gespeichert.',
  'admin.message.tenantDeleted': 'Tenant {name} gelöscht.',
  'admin.message.locationSaved': 'Standort {name} gespeichert.',
  'admin.message.locationDeleted': 'Standort {name} gelöscht.',
  'admin.message.userSaved': 'Benutzer {name} gespeichert.',
  'admin.message.userDeleted': 'Benutzer {name} gelöscht.',
  'admin.message.controllerVendorSaved': 'Controller-Vendor {name} erstellt.',
  'admin.message.pmsVendorSaved': 'PMS-Vendor {name} erstellt.',
  'admin.message.controllerVendorUpdated': 'Controller-Vendor {name} aktualisiert.',
  'admin.message.pmsVendorUpdated': 'PMS-Vendor {name} aktualisiert.',
  'admin.message.controllerVendorDeleted': 'Controller-Vendor {name} gelöscht.',
  'admin.message.pmsVendorDeleted': 'PMS-Vendor {name} gelöscht.',
  'admin.message.roomDeleted': 'Raum {name} gelöscht.',
  'admin.confirm.deleteTenant': 'Tenant {name} und alle verknüpften Standorte löschen?',
  'admin.confirm.deleteLocation': 'Standort {name} und seine Infrastruktur löschen?',
  'admin.confirm.deleteUser': 'Benutzer {name} löschen?',
  'admin.confirm.deleteRoom': 'Raum {name} löschen?',
  'admin.confirm.deleteControllerVendor': 'Controller-Vendor {name} löschen?',
  'admin.confirm.deletePmsVendor': 'PMS-Vendor {name} löschen?',
  'reception.tab.events': 'Veranstaltungen',
  'reception.actions.sendEmail': 'Per E-Mail senden',
  'reception.message.emailed': 'Code {id} wurde per E-Mail gesendet.',
  'events.kicker': 'Veranstaltungs-WLAN',
  'events.title': 'Veranstaltungszugänge erstellen und verwalten',
  'events.name': 'Veranstaltungsname',
  'events.hall': 'Veranstaltungsraum',
  'events.duration': 'Dauer',
  'events.code': 'Veranstaltungscode',
  'events.isolation': 'Client-Isolierung',
  'events.network.loading': 'Netzwerke werden geladen...',
  'events.network.empty': 'Keine Netzwerke verfügbar',
  'events.network.loadError': 'Netzwerke konnten nicht geladen werden',
  'events.isolated': 'Isoliert',
  'events.shared': 'Gemeinsamer Zugang',
  'events.policy': 'Richtlinie',
  'events.contactName': 'Kontaktname',
  'events.create': 'Neue Veranstaltung',
  'events.edit': 'Veranstaltung bearbeiten',
  'events.sendEmail': 'Code per E-Mail senden',
  'events.disable': 'Veranstaltung deaktivieren',
  'events.empty': 'Für diesen Standort sind keine Veranstaltungen konfiguriert.',
  'reception.tab.hotel': 'Hotel', 'reception.hotel.description': 'Zimmer- und Gemeinschaftsbereichscodes aus PMS oder Concierge', 'reception.hotel.kicker': 'Hotel-WLAN-Codes', 'reception.hotel.title': 'Codes für Zimmer und Gemeinschaftsbereiche verwalten',
  'admin.onboarding.kicker': 'Geführte Standortaufnahme', 'admin.onboarding.title': 'Neuen Standort erstellen und konfigurieren', 'admin.onboarding.description': 'Folgen Sie der Übergabe vom Anbieter an Lumen in der vorgegebenen Reihenfolge.',
  'admin.onboarding.step1': 'Controller', 'admin.onboarding.step2': 'Standort', 'admin.onboarding.step3': 'Integrationen', 'admin.onboarding.step4': 'Prüfung', 'admin.onboarding.step5': 'Prüfung',
  'admin.onboarding.locationKicker': 'Schritt 2 · Standortdaten', 'admin.onboarding.locationTitle': 'Daten des neuen Standorts eingeben',
  'admin.onboarding.controllerKicker': 'Schritt 1 · Anbieter-Verbindung', 'admin.onboarding.controllerTitle': 'Standort-Controller konfigurieren', 'admin.onboarding.controllerHelp': 'Hardware, RF, AP-Gruppen und Basis-SSIDs müssen auf der Anbieterplattform vorhanden sein.',
  'admin.onboarding.integrationsKicker': 'Schritt 3 · Optionale Integrationen', 'admin.onboarding.integrationsTitle': 'PMS, TV und E-Mail konfigurieren', 'admin.onboarding.reviewKicker': 'Schritt 4 · Prüfung', 'admin.onboarding.reviewTitle': 'Standortkonfiguration bestätigen', 'admin.onboarding.unitsNext': 'Konfigurieren Sie danach Zimmer, gemeinsame Einheiten und Veranstaltungsräume mit VLAN und Netzwerk.', 'admin.onboarding.saveContinue': 'Speichern und Einheiten konfigurieren',
  'reception.fields.selectSpace': 'Einheit auswählen',
  'reception.category.journalist': 'Journalist',
  'reception.category.relator': 'Referent',
  'reception.categoryDescription.staff': 'Der Code wird im voreingestellten VLAN erstellt.',
  'reception.categoryDescription.iot': 'Der Code wird im voreingestellten VLAN erstellt.',
  'reception.categoryDescription.visitor': 'Der Code wird im voreingestellten VLAN erstellt.',
  'reception.categoryDescription.guest': 'Zimmer auswählen, um das zugehörige VLAN zuzuweisen.',
  'events.message.saved': 'Veranstaltung {name} gespeichert.',
  'events.message.emailSent': 'Veranstaltungscode an {email} gesendet.',
  'events.message.disabled': 'Veranstaltung {name} deaktiviert.',
  'events.codes.kicker': 'Gäste- und Besucherverwaltung',
  'events.codes.manage': 'Veranstaltungscodes verwalten',
  'events.codes.type': 'Codetyp',
  'events.codes.mode': 'Erstellungsmodus',
  'events.codes.personal': 'Persönlich',
  'events.codes.manual': 'Manuell',
  'events.codes.bulk': 'Massenimport',
  'events.codes.personalManual': 'Persönlich · Manuell',
  'events.codes.personalBulk': 'Persönlich · Massenimport',
  'events.codes.group': 'Gruppe',
  'events.codes.manualTitle': 'Persönlichen Code erstellen',
  'events.codes.bulkTitle': 'Persönliche Codes aus CSV importieren',
  'events.codes.groupTitle': 'Gruppencode erstellen',
  'events.codes.groupName': 'Gruppenname',
  'events.codes.sendEmail': 'Code per E-Mail senden',
  'events.codes.service': 'Service',
  'events.codes.serviceHint': 'Das für den Veranstaltungsraum konfigurierte Service-VLAN verwenden.',
  'events.codes.serviceUnavailable': 'Für den ausgewählten Raum ist kein Service-VLAN konfiguriert.',
  'events.codes.bulkHint': 'Pflichtspalten: firstName, lastName, email, category, devicesAllowed. Dauer und Raum werden von der Veranstaltung übernommen; die Verarbeitung wird zur Einhaltung der Anbieter-Ratenlimits in die Warteschlange gestellt.',
  'events.codes.createPersonal': 'Persönlichen Code erstellen',
  'events.codes.createGroup': 'Gruppencode erstellen',
  'events.codes.queueBulk': 'CSV-Import einreihen',
  'events.codes.personalCreated': 'Persönlicher Code erstellt: {code}',
  'events.codes.groupCreated': 'Gruppencode erstellt: {code}',
  'events.codes.bulkQueued': 'Import {id} eingereiht: {imported} Codes verarbeitet.',
  'admin.unitsBulk.action': 'Massenimport',
  'admin.unitsBulk.kicker': 'Massenimport von Einheiten',
  'admin.unitsBulk.title': 'Einheiten aus CSV importieren',
  'admin.unitsBulk.description': 'Zimmer, Gemeinschaftsbereiche und Veranstaltungssäle in einem Vorgang erstellen.',
  'admin.unitsBulk.loadFile': 'CSV laden',
  'admin.unitsBulk.csv': 'Einheiten-CSV',
  'admin.unitsBulk.hint': 'Spalten: name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. Erforderlich: name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'Import läuft...',
  'admin.unitsBulk.import': 'Einheiten importieren',
  'admin.unitsBulk.completed': '{count} Einheiten importiert.',
  'admin.unitsBulk.invalid': 'Ungültige CSV: {error}',
  'admin.unitsBulk.noRows': 'Keine Datenzeilen gefunden.',
  'admin.unitsBulk.missingColumns': 'Fehlende Spalten: {columns}.',
  'admin.unitsBulk.rowError': 'Ungültige Werte in Zeile {row}.',
};
